import { GlobalStyles } from "@mui/material";

const ReportPrintStyles: React.FC = () => (
  <GlobalStyles
    styles={{
      "@media print": {
        "@page": {
          size: "A4 landscape",
          margin: 0,
        },
        "html, body": {
          margin: "0 !important",
          padding: "0 !important",
          background: "#ffffff !important",
        },
        "body.report-print-mode *": {
          visibility: "hidden",
        },
        "body.report-print-mode #main, body.report-print-mode #main *": {
          visibility: "visible",
        },
        "body.report-print-mode, body.report-print-mode #root, body.report-print-mode #main":
          {
            width: "100% !important",
            height: "auto !important",
            margin: "0 !important",
            padding: "0 !important",
            overflow: "visible !important",
            background: "#ffffff !important",
          },
        "body.report-print-mode #main": {
          position: "absolute !important",
          inset: "0 auto auto 0 !important",
          boxSizing: "border-box !important",
        },
      },
    }}
  />
);

export default ReportPrintStyles;
